import { tips } from '../config'

export default tips